module.exports = __webpack_public_path__ + "media/images/blue-boy-874189e7a1d2a9a7e33d0cacdc1ee1a5.jpg";